import { render, staticRenderFns } from "./GridResumen.vue?vue&type=template&id=4b64c08a&"
import script from "./GridResumen.vue?vue&type=script&lang=ts&"
export * from "./GridResumen.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports